import { get, post } from '@/request/http';
// eslint-disable-next-line import/no-extraneous-dependencies
import QS from 'qs';
import JSEncrypt from '../../jsencrypt';

const CommonForms = {
  /**
   * 获取ui配置表单信息
   */
  getUiConfig(params) {
    return post('/backloansuper/loan/supermarket/product/config/v1.0', params, {
      'Content-Type': 'application/json',
    });
  },
  /**
   * 获取微业银行跳转链接
   */
  getWeBankURL(params) {
    return post('/backloansuper/loan/supermarket/getWeBankURL/v1.0', params, {
      'Content-Type': 'application/json',
    });
  },
  /**
   * 获取微业银行二维码内容
   */
  getScanCode(params) {
    return post('/backloansuper/loan/supermarket/getWeBankInviteCode/v1.0', params, {
      'Content-Type': 'application/json',
    });
  },
  /**
   * 获取地区编码
   */
  getAreaList() {
    return get('/backloansuper/loan/supermarket/getAreaCountry/v1.1');
  },
  /**
   *  获取订单状态
   */
  getOrderStatus(params) {
    return post(
      '/backloansuper/loan/supermarket/bff/getOrderStatus',
      QS.stringify(params),
      {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      },
    );
  },
  /**
   *  标准化-提款失败重新提款按钮跳转
   */
  urlJumpPage(params) {
    return get('/backloansuper/loan/supermarket/urlJumpPage/v1.0', params, {
      'Content-Type': 'application/json',
    });
  },
  /**
   *
   * 获取回显信息
   */
  getInformation(orderId) {
    if (!orderId) {
      return Promise.resolve({ returnMessage: '暂无订单信息' });
    }
    console.log(orderId, '>>??>>');
    return post(
      '/backloansuper/loan/supermarket/getLoanOrder/v1.0',
      { orderId },
      {
        'Content-Type': 'application/json',
      },
    );
  },
  // 保存第一个进件页面
  saveFirstOrderInfo(params) {
    return post('/backloansuper/loan/supermarket/saveFirstOrder/v1.0', params, {
      'Content-Type': 'application/json',
    });
  },
  /**
   * 保存第二个进件页面
   */
  saveLoaderInfoInformation(params) {
    const obj = JSON.parse(JSON.stringify(params));
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey('MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ==');
    console.log(obj.bankCard, encrypt.encrypt(obj.bankCard), 877777);
    obj.bankCard = encrypt.encrypt(`${obj.bankCard}`);
    obj.legalPhone = encrypt.encrypt(`${obj.legalPhone}`);
    obj.legalIdentity = encrypt.encrypt(`${obj.legalIdentity}`);
    obj.borrowerIdentity = encrypt.encrypt(`${obj.borrowerIdentity}`);
    obj.borrowerPhone = encrypt.encrypt(`${obj.borrowerPhone}`);
    obj.creditBankCard = encrypt.encrypt(`${obj.creditBankCard}`);
    obj.iceContactPhone = encrypt.encrypt(`${obj.iceContactPhone}`);
    obj.iceContactIdentity = encrypt.encrypt(`${obj.iceContactIdentity}`);
    console.log(obj.bankCard, encrypt.encrypt(obj.bankCard), 877777);
    return post('/backloansuper/loan/supermarket/saveSecondOrder/v1.0', obj, {
      'Content-Type': 'application/json',
    });
  },
  /**
   * 第二个进件页面获取法人信息
   */
  getCorpInfoInformation() {
    const params = { key: localStorage.getItem('token') };
    return post('/backloansuper/loan/supermarket/getUserInfo', params);
  },
  /**
   *
   * 获取短信验证码
   */
  getMessageCode(params) {
    return post('/backloansuper/loan/supermarket/smsWithLogin/v1.0', params);
  },
  /**
   *
   * 获取短信验证码(调用接口名动态获取)
   */
  getDynamicMessageCode(params) {
    return post(params.smsUrl, params);
  },
  /**
   *
   * 获取短信验证码
   */
  getBankMessageCode(params) {
    return post('/backloansuper/loan/supermarket/smsSpdb/v1.0', params);
  },
  /**
   * 跑模型
   */
  getModelRun(params) {
    return post('/backloansuper/loan/supermarket/execModel/v1.0', params, {
      'Content-Type': 'application/json',
    });
  },
  /**
   * 无法评估跑模型的方法
   */
  getModelRunServer(params) {
    return post('/backloansuper/loan/supermarket/execModel/v2.0', params, {
      'Content-Type': 'application/json',
    });
  },
  /**
   * 授信失败重新填写重置订单状态
   */
  rewriteWhenFailure(params) {
    return post('/backloansuper/loan/supermarket/rewrite/v1.0', params);
  },
  // 上传失败重新填写原hanhua逻辑
  resetCreditFailOrder(params) {
    return post('/backloansuper/resetCreditFailOrder', params, {
      'Content-Type': 'application/json',
    });
  },
  // 第三方逻辑server
  jumpThirdServer(params) {
    return get(
      `/backloansuper/loan/supermarket/jumpCurrPage/v1.0?orderId=${params.orderId}`,
    );
  },
  // 上传身份证照片
  checkIdentityPicService(params) {
    return post(
      '/backloansuper/loan/supermarket/checkIdentityPic/v1.0',
      params,
      {
        'Content-Type': 'multipart/form-data',
      },
    );
  },
  ocrByAggsOrderId(params) {
    return get(
      `/backloansuper/loan/supermarket/identity/ocrByAggsOrderId/v1.0?aggsOrderId=${params.aggsOrderId}`,
    );
  },
  
  // 上传 营业执照
  uploadBusiImageServer(params) {
    return post(
      '/backloansuper/loan/supermarket/uploadBusiImage/v1.0',
      params,
      {
        'Content-Type': 'multipart/form-data',
      },
    );
  },
  // 上传 营业执照 - ocr识别
  licenseOcr(params) {
    return post(
      '/backloansuper/loan/supermarket/licenseOcr/v1.0',
      params,
      {
        'Content-Type': 'multipart/form-data',
      },
    );
  },
  // 上传 营业执照 - 提交
  saveLicenseOcr(params) {
    return post('/backloansuper/loan/supermarket/saveLicenseOcr/v1.0', params, {
      dataType: 'json',
    });
  },
  // 上传 营业执照 - 苏宁
  uploadBusiImageSNServer(params) {
    return post(
      '/backloansuper/loan/supermarket/uploadBusiImage/v2.0',
      params,
      {
        'Content-Type': 'multipart/form-data',
      },
    );
  },
  // 授信成功 初审成功变更状态接口
  nextJumpPageServer(params) {
    return get(
      `/backloansuper/loan/supermarket/jumpNextPage/v1.0?orderId=${params.orderId}`,
    );
  },
  // 获取4位随机验证码
  getRandomNumber(params) {
    return post('/backloansuper/loan/supermarket/faceLabel/v1.0', params, {
      dataType: 'json',
    });
  },
  // 获取4位随机验证码（订单外）
  getRandomNumberOut(params) {
    return post('/backloansuper/loan/supermarket/faceLabel/v2.0', params, {
      dataType: 'json',
    });
  },
  // 人脸识别
  lipCheck(data) {
    return post('/backloansuper/loan/supermarket/face/v1.0', data, {
      processData: false, // 用于对data参数进行序列化处理 这里必须false
      contentType: false, // 必须
      responseType: 'json',
    });
  },
  // 浦发人脸识别
  setLipCheck(data) {
    return post(
      '/backloansuper/loan/supermarket/face/v2.0', data, {
      processData: false, // 用于对data参数进行序列化处理 这里必须false
      contentType: false, // 必须
      responseType: 'json',
    },
    );
  },
  // 订单外人脸识别
  setLipCheckOut(data) {
    return post(
      '/backloansuper/loan/supermarket/face/v3.0', data, {
      processData: false, // 用于对data参数进行序列化处理 这里必须false
      contentType: false, // 必须
      responseType: 'json',
    },
    );
  },
  // 浦发轮询问接口
  getSpdbDrawStatus(params) {
    return post(
      '/backloansuper/loan/supermarket/getSpdbDrawStatus/v1.0',
      // '/backloansuper/loan/supermarket/getSpdbDrawStatus/v1.0',
      params,
    );
  },
  // 是否可以再次申请提款
  spdbCanApplyDraw(params) {
    return post(
      '/backloansuper/loan/supermarket/spdbCanApplyDraw/v1.0',
      // '/backloansuper/loan/supermarket/spdbCanApplyDraw/v1.0',
      params,
    );
  },
  // 提款申请初始化
  getSpdbApplyDrawInfo(params) {
    return post(
      '/backloansuper/loan/supermarket/getSpdbApplyDrawInfo/v1.0',
      // '/backloansuper/loan/supermarket/getSpdbApplyDrawInfo/v1.0',
      params,
    );
  },
  // 浦发优企贷-提款申请初始化
  getSpdbYQDApplyDrawInfo(params) {
    return post(
      '/backloansuper/loan/supermarket/getSpdbYQDApplyDrawInfo/v1.0',
      params,
    );
  },
  // 浦发优企贷-满意物流
  getSYqdApplyDrawInfo(params) {
    return post(
      '/backloansuper/loan/supermarket/getSYqdApplyDrawInfo/v1.0',
      params,
    );
  },

  // 提款申请提交数据
  spdbDrawApply(params) {
    return post('/backloansuper/loan/supermarket/spdbDrawApply/v1.0', params);
  },
  // 浦发优企贷-提款申请提交数据
  spdbYQDDrawApply(params) {
    return post('/backloansuper/loan/supermarket/spdbYQDDrawApply/v1.0', params);
  },

  // 获取产品信息接口
  getProductConfig(params) {
    return post('/backloansuper/loan/supermarket/product/config/v1.0', params);
  },


  // 浦发开二类户
  // 身份证信息回显
  getUploadIdentityUrl(params) {
    return post('/backloansuper/loan/supermarket/queryIdentityPic/v1.0', params);
  },
  // 身份证提交
  openBankIdentityPicService(params) {
    return post('/backloansuper/loan/supermarket/uploadIdentityPic/v1.0', params);
  },
  // 支持的银行
  getbanklist(params) {
    return post('/backloansuper/loan/supermarket/bankList/v1.0', params);
  },
  // 支持的银行
  querySupportBanks(params) {
    return post('/backloansuper/loan/supermarket/querySupportBanks', params);
  },
  // 选择行业
  getColumnsTermMethod(params) {
    return post('/backloansuper/loan/supermarket/occupationList/v1.0', params);
  },
  queryLimit(params) {
    return post('/backloansuper/loan/supermarket/queryLimit', params);
  },
  applyLoan(params) {
    return post('/backloansuper/loan/supermarket/applyLoan', params);
  },
  checkBindCard(params) {
    return post('/backloansuper/loan/supermarket/checkBindCard', params);
  },
  verifyBindCard(params) {
    return post('/backloansuper/loan/supermarket/verifyBindCard', params);
  },
  queryBankCard(params) {
    return post('/backloansuper/loan/supermarket/queryBankCard', params);
  },
  // 开户信息提交
  openBankInfo(params) {
    return post('/backloansuper/loan/supermarket/openAccount/v1.0', params);
  },
  // 开卡状态查询
  getOpenBankState(params) {
    return post('/backloansuper/loan/supermarket/openAccountQuery/v1.0', params);
  },
  // 开卡成功信息
  getOpenBankSucessInfo(params) {
    return post('/backloansuper/api/user/kaihusu', params);
  },
  // 银行卡回显
  getBankInfo(params) {
    return post('/backloansuper/loan/supermarket/bankCard/v1.0', params);
  },
  // mock 用户信息回显
  getMockInfo(params) {
    return get('/backloansuper/loan/supermarket/getLoanOrder/v1.0', params);
  },
  // 资金账户余额查询
  getBalance(params) {
    return post('/backloansuper/loan/supermarket/queryBalance/v1.0', params);
  },
  // 选择收款账户列表
  getAccountList(params) {
    return post('/backloansuper/loan/supermarket/bindingCardQuery/v1.0', params);
  },
  // 充值
  bandlerRecharge(params) {
    return post('/backloansuper/loan/supermarket/deposit/v1.0', params);
  },
  // 充值查询
  depositQuery(params) {
    return post('/backloansuper/loan/supermarket/depositQuery/v1.0', params);
  },
  // 提现
  bandlerWithdrawal(params) {
    return post('/backloansuper/loan/supermarket/transfer/v1.0', params);
    // return post(`https://www.fastmock.site/mock/1e4ab37bd4f2009a9c6b831849505a66/backloansuper/backloansuper/loan/supermarket/transfer/v1.0`, params)
  },
  // 提现查询
  transferQuery(params) {
    // return post(`https://www.fastmock.site/mock/1e4ab37bd4f2009a9c6b831849505a66/backloansuper/backloansuper/loan/supermarket/transferQuery/v1.0`, params)
    return post('/backloansuper/loan/supermarket/transferQuery/v1.0', params);
  },
  // 交易记录
  tranDetailList(params) {
    return post('/backloansuper/loan/supermarket/tranDetailList/v1.0', params);
  },
  // 通过productid获取邀请码
  getInvitedCodeFromProductId(params) {
    return post(
      '/backloansuper/loan/supermarket/invite/addPaInviteCode/v1.0',
      params,
    );
  },
  // 浦发二类专户验证码获取
  getRandPwd(params) {
    return post(
      '/backloansuper/loan/supermarket/randPwd/v1.0',
      params,
    );
  },
  // 浦发二类专户新增绑定卡
  addBindNewCard(params) {
    return post(
      '/backloansuper/loan/supermarket/bindNewCard/v1.0',
      params,
    );
  },
  // 浦发二类专户新增绑定卡结果查询
  getBindNewCardQuery(params) {
    return post(
      '/backloansuper/loan/supermarket/bindNewCardQuery/v1.0',
      params,
    );
  },
  // 浦发二类专户解除绑定卡
  getUnbindCard(params) {
    return post(
      '/backloansuper/loan/supermarket/unbindCard/v1.0',
      params,
    );
  },
  // 浦发二类专户激活
  getActivate(params) {
    return post(
      '/backloansuper/loan/supermarket/activate/v1.0',
      params,
    );
  },
  // 浦发二类专户激活结果查询
  getActivateQuery(params) {
    return post(
      '/backloansuper/loan/supermarket/activateQuery/v1.0',
      params,
    );
  },
  // 是否展示核心企业选择页面接口
  getCoreCorpPage(params) {
    return post(
      '/backloansuper/loan/supermarket/getCoreCorpPage/v1.0',
      params,
    );
  },
  // 初审时，下一步调用白名单
  dataWhiteList(orderId) {
    return post('/backloansuper/loan/supermarket/corpWhiteList/v1.0', orderId);
  },
  cardBindingSuccess(params) {
    return post('/backloansuper/loan/supermarket/cardBindingSuccess', params);
  },
  
};

export default CommonForms;
